module.exports = __webpack_public_path__ + "static/img/wechat_shouquanshuoming.ac704cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kfc/wechat_shouquanshuoming.png
// module id = FLIN
// module chunks = 0